<template>
  <card-order-review-data
    class="card-order-register-modal"
    heading="Please, check all information again and confirm card order"
    :card-order="cardOrder"
    :card-order-profile="cardOrderProfile"
  >
    <template slot="actions">
      <v-btn
        class="t-confirm-order"
        color="primary"
        flat="flat"
        :disabled="registerCardOrderApiRequest.loading"
        @click="onRegisterButtonClick"
      >
        <v-progress-circular
          v-if="registerCardOrderApiRequest.loading"
          color="primary"
          size="22"
          width="3"
          class="mr-2"
          indeterminate
        />
        <span>confirm card order</span>
      </v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        flat="flat"
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </card-order-review-data>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Utils
  import { createCardOrderListRoute, createCardOrderEditRoute } from '@/utils/routing/Issuing'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import IssuingApi from '@/services/Api/IssuingApi'

  // Components
  import CardOrderReviewData from '@/components/cards/CardOrderReviewData'

  export default {
    name: 'CardOrderRegisterModal',
    components: {
      CardOrderReviewData
    },
    data () {
      return {
        registerCardOrderApiRequest: new ApiRequest(IssuingApi.registerCardOrder)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      cardOrder () {
        return this.modal.data.cardOrder
      },
      cardOrderProfile () {
        return this.modal.data.cardOrderProfile
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onRegisterButtonClick () {
        this.registerCardOrderApiRequest
          .execute(this.cardOrder.id)
          .then(this.cardOrderRegisterSuccessHandler)
          .catch(this.cardOrderRegisterErrorHandler)
      },
      onCancelButtonClick () {
        this.closeModal()
      },
      cardOrderRegisterSuccessHandler () {
        this.showModal({
          name: 'SuccessFlashModal',
          data: {
            redirectPath: createCardOrderListRoute(),
            message: 'Card order has been successfully registered.'
          }
        })
      },
      cardOrderRegisterErrorHandler (error) {
        const validationErrors = error.findValidationErrors()
        let modalData = { message: error.message }

        if (validationErrors.length > 0) {
          modalData = {
            ...modalData,
            redirectPath: createCardOrderEditRoute(
              this.cardOrder.id,
              { params: { data: error } }
            )
          }
        }

        this.showModal({
          name: 'ErrorFlashModal',
          timeout: 3000,
          data: modalData
        })
      }
    }
  }
</script>
